module.exports = __webpack_public_path__ + "img/colorBox9.f8aff1ca.jpg";